import React from 'react';
import { Recommendation } from '../types/camera';

interface RecommendationDisplayProps {
  recommendation: Recommendation;
  cameraName: string | null;
  onStartOver: () => void;
}

const RecommendationDisplay: React.FC<RecommendationDisplayProps> = ({
  recommendation,
  cameraName,
  onStartOver
}) => {
  const { settings, tips, warnings } = recommendation;

  return (
    <div className="recommendation-display">
      <h2>
        Recommended Settings
        {cameraName && <span className="camera-name"> for {cameraName}</span>}
      </h2>
      
      <div className="settings-grid">
        <div className="setting-item">
          <strong>Resolution:</strong> {settings.resolution}
        </div>
        <div className="setting-item">
          <strong>Frame Rate:</strong> {settings.framerate}
        </div>
        <div className="setting-item">
          <strong>Field of View:</strong> {settings.fov}
        </div>
        <div className="setting-item">
          <strong>Stabilization:</strong> {settings.stabilization}
        </div>
        <div className="setting-item">
          <strong>ISO:</strong> {settings.iso}
        </div>
        {settings.shutterSpeed && (
          <div className="setting-item">
            <strong>Shutter Speed:</strong> {settings.shutterSpeed}
          </div>
        )}
        <div className="setting-item">
          <strong>White Balance:</strong> {settings.whiteBalance}
        </div>
        <div className="setting-item">
          <strong>Exposure:</strong> {settings.exposure}
        </div>
        {settings.colorProfile && (
          <div className="setting-item">
            <strong>Color Profile:</strong> {settings.colorProfile}
          </div>
        )}
        {settings.bitrate && (
          <div className="setting-item">
            <strong>Bitrate:</strong> {settings.bitrate}
          </div>
        )}
        {settings.focalLength && (
          <div className="setting-item">
            <strong>Focal Length:</strong> {settings.focalLength}
          </div>
        )}
        {settings.ev && (
          <div className="setting-item">
            <strong>EV Compensation:</strong> {settings.ev}
          </div>
        )}
      </div>

      {/* Advanced DJI Action 5 Settings */}
      {(settings.colorRecovery || settings.color || settings.texture || settings.noiseReduction) && (
        <div className="advanced-settings">
          <h3>Advanced Color & Image Settings</h3>
          <div className="settings-grid">
            {settings.colorRecovery && (
              <div className="setting-item">
                <strong>Color Recovery:</strong> {settings.colorRecovery}
              </div>
            )}
            {settings.color && (
              <div className="setting-item">
                <strong>Color:</strong> {settings.color}
              </div>
            )}
            {settings.texture && (
              <div className="setting-item">
                <strong>Texture:</strong> {settings.texture}
              </div>
            )}
            {settings.noiseReduction && (
              <div className="setting-item">
                <strong>Noise Reduction:</strong> {settings.noiseReduction}
              </div>
            )}
          </div>
        </div>
      )}

      <div className="reasoning">
        <h3>Why These Settings?</h3>
        <p>{settings.reasoning}</p>
      </div>

      {tips && tips.length > 0 && (
        <div className="tips">
          <h3>Pro Tips</h3>
          <ul>
            {tips.map((tip, index) => (
              <li key={index}>{tip}</li>
            ))}
          </ul>
        </div>
      )}

      {warnings && warnings.length > 0 && (
        <div className="warnings">
          <h3>Important Notes</h3>
          <ul>
            {warnings.map((warning, index) => (
              <li key={index}>{warning}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="actions">
        <button onClick={onStartOver} className="start-over-button">
          Get New Recommendations
        </button>
      </div>
    </div>
  );
};

export default RecommendationDisplay;